import React from 'react';

import EditColumnsButton from '../../../../components/edit-columns-button';
import { EditProductsColumnsModalContainer } from '../../../../containers/edit-products-columns-modal-container';
import { useModal } from '../../../../hooks/use-modal';

const EditProductsGridColumnsButton = () => {
  const { close, isOpen, open } = useModal();

  return (
    <React.Fragment>
      <EditColumnsButton onClick={open} />
      {isOpen && <EditProductsColumnsModalContainer onClose={close} />}
    </React.Fragment>
  );
};

export default EditProductsGridColumnsButton;
